<dx-tag-box
  #tagbox
  [items]="data"
  [valueExpr]="key"
  [showSelectionControls]="true"
  [displayExpr]="displayValue"
  [searchEnabled]="enableSearch"
  [searchExpr]="displayValue"
  searchMode="contains"
  applyValueMode="useButtons"
  [maxDisplayedTags]=maxDisplayedTags
  [showMultiTagOnly]="false"
  [multiline]="false"
  (onValueChanged)="valueChanged($event)"
  [placeholder]="placeholder"
  [value]="selectedItems"
  [readOnly]="readOnly"
  [disabled]="disabled"
  [dropDownOptions]="dropDownOptions"
  itemTemplate="customItem"
>
  <div *dxTemplate="let item of 'customItem'">

    <ng-container *ngIf="itemTemplate; else defaultTpl">
      <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
    </ng-container>

    <ng-template #defaultTpl>
      <span [attr.title]="tooltipExpr() ? item[tooltipExpr()] : null">
        {{ item[displayValue] }}
      </span>
    </ng-template>
  </div>
</dx-tag-box>
